import throttle from 'lodash/throttle';
import { autorun } from 'mobx';
import { getStore } from './stores';

//global
const state = {
	initialized: false,
};

const classes = {
	navCaw: 'NavigationCAW',
	trigger: 'CAW-trigger',
	calRow: 'Calendar-row',
	hideBtn: 'hideButton',
	hasEliteGuestComponent: 'hasEliteGuestComponent',
	checkRatesCtaCawTrigger: `CheckRates-cta-caw-trigger`,
	checkRatesCtaDefaultTrigger: `default-trigger`,
	stickyCheckRates: 'Navigation-stickyCheckRates',
	stickyGradient: 'Navigation-stickyCheckRates-gradient',
};
const $window = $(window);

const setupStickyCheckRates = () => {
	const stickyCheckRates = document.querySelector(`.${classes.stickyCheckRates}`);
	const stickyGradient = document.querySelector(`.${classes.stickyGradient}`);
	const fullscreenHero = document.querySelector('.FullscreenHero');
	const heroCheckRates = document.querySelector('.FullscreenHero-checkRatesCta');
	const conversationCardCheckRates = document.querySelector('.ConversationCard-checkRatesCta');
	const hasFullscreenHero = fullscreenHero !== null;
	const hasConversationCard = fullscreenHero?.classList.contains('has-conversation-card');
	const headerHeight = 120;

	// Calculate dynamic threshold based on window width
	const getDynamicThreshold = () => {
		const breakpoints = [
			{ width: 337, threshold: 8 },
			{ width: 462, threshold: 9 },
			{ width: 575, threshold: 10 },
			{ width: 700, threshold: 10 },
		];

		const currentWidth = window.innerWidth;

		// If width is less than first breakpoint, return first threshold
		if (currentWidth <= breakpoints[0].width) {
			return breakpoints[0].threshold;
		}

		// If width is greater than last breakpoint, return last threshold
		if (currentWidth >= breakpoints[breakpoints.length - 1].width) {
			return breakpoints[breakpoints.length - 1].threshold;
		}

		// Find the appropriate breakpoint range
		for (let i = 0; i < breakpoints.length - 1; i++) {
			const current = breakpoints[i];
			const next = breakpoints[i + 1];

			if (currentWidth > current.width && currentWidth <= next.width) {
				// Calculate percentage between current and next breakpoint
				const range = next.width - current.width;
				const position = currentWidth - current.width;
				const percentage = position / range;

				// Interpolate threshold value
				return current.threshold + percentage * (next.threshold - current.threshold);
			}
		}

		return 10;
	};

	if (!stickyCheckRates) return;

	let stickyVisible = false;
	let lastScrollTop = 0;

	// If no fullscreen hero, show sticky check rates at the bottom
	if (!hasFullscreenHero) {
		stickyCheckRates.classList.add('is-visible');
		stickyCheckRates.classList.add('is-bottom');
		if (stickyGradient) {
			stickyGradient.classList.add('is-visible');
			stickyGradient.classList.add('is-bottom');
		}
		stickyVisible = true;
	} else {
		const handleScroll = throttle(() => {
			const scrollTop = window.scrollY;
			const isScrollingDown = scrollTop > lastScrollTop;

			// Calculate scroll percentage
			const documentHeight =
				document.documentElement.scrollHeight - document.documentElement.clientHeight;
			const scrollPercentage = Math.round((scrollTop / documentHeight) * 100);
			const currentThreshold = getDynamicThreshold();

			if (heroCheckRates || conversationCardCheckRates) {
				const heroButtonRect = heroCheckRates
					? heroCheckRates.getBoundingClientRect()
					: null;
				const conversationCardButtonRect = conversationCardCheckRates
					? conversationCardCheckRates.getBoundingClientRect()
					: null;

				// Get the bottom position of the visible check rates button
				const heroButtonBottom = heroButtonRect ? heroButtonRect.bottom : Infinity;
				const conversationCardButtonBottom = conversationCardButtonRect
					? conversationCardButtonRect.bottom
					: Infinity;
				const visibleButtonBottom = Math.min(
					heroButtonBottom,
					conversationCardButtonBottom
				);

				const isElementOutOfView = rect => rect && rect.top < 0;

				// For ConversationCard in FullscreenHero, show after percentage threshold
				if (hasConversationCard) {
					if (scrollPercentage >= currentThreshold && isScrollingDown && !stickyVisible) {
						stickyCheckRates.classList.add('is-visible');
						stickyCheckRates.classList.add('is-sticky');
						if (stickyGradient) {
							stickyGradient.classList.add('is-visible');
							stickyGradient.classList.add('is-sticky');
						}
						stickyVisible = true;
					} else if (scrollPercentage < currentThreshold && stickyVisible) {
						stickyCheckRates.classList.remove('is-visible');
						stickyCheckRates.classList.remove('is-sticky');
						if (stickyGradient) {
							stickyGradient.classList.remove('is-visible');
							stickyGradient.classList.remove('is-sticky');
						}
						stickyVisible = false;
					}
				} else {
					const shouldShowSticky =
						isElementOutOfView(heroButtonRect) && isScrollingDown && !stickyVisible;

					const shouldHideSticky = !isElementOutOfView(heroButtonRect) && stickyVisible;

					if (shouldShowSticky) {
						stickyCheckRates.classList.add('is-visible');
						stickyCheckRates.classList.add('is-sticky');
						if (stickyGradient) {
							stickyGradient.classList.add('is-visible');
							stickyGradient.classList.add('is-sticky');
						}
						stickyVisible = true;
					} else if (shouldHideSticky) {
						stickyCheckRates.classList.remove('is-visible');
						stickyCheckRates.classList.remove('is-sticky');
						if (stickyGradient) {
							stickyGradient.classList.remove('is-visible');
							stickyGradient.classList.remove('is-sticky');
						}
						stickyVisible = false;
					}
				}
			}

			lastScrollTop = scrollTop;
		}, 100);

		// Initial setup
		$window.on('scroll', handleScroll);
	}

	// Listen for CAW close event to reset active states
	window.addEventListener('cawComponentClose', () => {
		const allCheckRatesButtons = document.querySelectorAll(
			`.${classes.stickyCheckRates} .${classes.checkRatesCtaCawTrigger}`
		);
		allCheckRatesButtons.forEach(button => {
			button.classList.remove('is-active');
		});
	});
};

export { setupStickyCheckRates };

const checkRatesCtaCawTrigger = async () => {
	const planStore = await getStore('planStore');
	autorun(async () => {
		if (planStore?.fetching === false) {
			const embeddedBookingEnabled = await planStore.embeddedBookingEnabled();
			if (embeddedBookingEnabled) {
				$('body').on('click', `.${classes.checkRatesCtaCawTrigger}`, event => {
					event.preventDefault();
					window.FS.Tealium.trackInteraction(
						'integrated booking engine',
						'check rates',
						'body'
					);
					window.dispatchEvent(
						new CustomEvent('cawComponentOpen', { detail: { setFocusTo: 'dates' } })
					);
				});
			} else {
				$('body').on(
					'click',
					`.${classes.checkRatesCtaCawTrigger}.${classes.checkRatesCtaDefaultTrigger}`,
					event => {
						event.preventDefault();
						window.FS.Tealium.trackInteraction(
							'integrated booking engine',
							'check rates',
							'body'
						);
						window.dispatchEvent(new Event('cawComponentOpen'));
					}
				);
			}
		}
	});
};

export default function checkAvailabilityWidget() {
	let init = () => {
		if (!state.initialized) {
			state.initialized = true;

			const $navCaw = $(`.${classes.navCaw}`);
			const $hideBtn = $(`.${classes.hideBtn}`);

			let closeOnScroll = true;

			//we want to delay this until other js is done as otherwise the animate is too laggy or won't be visible
			setTimeout(() => {
				$('body').on('click', `.${classes.trigger}`, event => {
					if (window.outerWidth >= '1100' && $navCaw.length) {
						event.preventDefault();
						window.FS.Tealium.trackInteraction(
							'integrated booking engine',
							'check rates',
							'global nav header'
						);
						event.stopImmediatePropagation();
						openClose(false, false, event.target);
					}
				});
				// Check if we are on internal properties page
				const shouldOpenAutomatically = $navCaw.hasClass('NavigationCAW--open');
				// show the CAW if the user hasn't manually closed it this session
				if (!sessionStorage.getItem('userClosedPopupCaw') && shouldOpenAutomatically) {
					openClose(false, true);
				}
				let lastScrollTop = $window.scrollTop();
				const handleScroll = throttle(() => {
					const st = $window.scrollTop();
					if (st > lastScrollTop) {
						// downscroll
						closeOnScroll = true;
					}
					lastScrollTop = st;
					const $calRow = $(`.${classes.calRow}`);
					if ($calRow.length) {
						if (!$calRow.first().hasClass('hideCaw')) {
							closeOnScroll = false;
						}
					}
					if (closeOnScroll) {
						openClose(true);
					}
				}, 5);
				$(window).scroll(handleScroll);
			});

			checkRatesCtaCawTrigger();
			setupStickyCheckRates();

			// Listen for conversation card ready event to re-run setupStickyCheckRates
			window.addEventListener('conversationCardReady', () => {
				setupStickyCheckRates();
			});

			window.addEventListener('cawComponentClose', () => {
				openClose(true);
				sessionStorage.setItem('userClosedPopupCaw', 1);
			});
			window.addEventListener('cawComponentOpen', event => {
				openClose(false, true);
				if (event?.detail?.setFocusTo === 'dates') {
					$('.Calendar-container .DateField').click();
				}
			});
			$('.InlineCarousel-prevButton, .InlineCarousel-nextButton').on('click', () => {
				openClose(true);
			});

			const openClose = (closeOnly, openOnly, element) => {
				const cawTrigger = $(element);
				const propertyCode = cawTrigger.data('caw-property-codes');
				if (propertyCode) {
					$navCaw.find('#destination-id').val(propertyCode);
				}
				const $cawButton = $(`.${classes.trigger}`);
				$hideBtn.attr('aria-controls', 'NavigationCAW');
				$cawButton.attr('aria-controls', 'NavigationCAW');
				if (
					!openOnly &&
					!propertyCode &&
					$navCaw.is(':visible') &&
					$navCaw.queue().length === 0
				) {
					$navCaw.slideUp({
						duration: 200,
					});
					$cawButton.finish();
					$cawButton.css('visibility', '');
					$cawButton.fadeTo(200, 1);
					$cawButton.attr('aria-expanded', 'false');
					$hideBtn.attr('aria-expanded', 'false');
					$navCaw.parents('nav').removeClass('caw-open');
				} else if (!closeOnly) {
					$navCaw.slideDown({
						duration: 200,
					});
					$cawButton.finish();
					$cawButton.fadeTo(200, 0, () => {
						$cawButton.css('visibility', 'hidden');
					});
					$cawButton.attr('aria-expanded', 'true');
					$hideBtn.attr('aria-expanded', 'true');
					$navCaw.parents('nav').addClass('caw-open');

					if ($window.scrollTop() < 200) {
						setTimeout(() => {
							$('.cawComponent').focus();
						}, 200);
					}
				}
				closeOnScroll = false;
			};
		}
	};

	if (window.cawComponentLoaded) {
		init();
	} else {
		window.addEventListener('cawComponentLoaded', () => {
			init();
		});
	}
}
